import { makeStyles, createStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    paper: {
      minWidth: "600px",
    },
    title: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    iconButton: {
      padding: 4,
      color: theme.palette.error.main,
    },
    cancelButton: {
      color: theme.palette.error.main,
    },
  })
)

export default useStyles
